import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Article header section
export const ArticleHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

// Article meta information
export const ArticleMeta = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
  flexWrap: 'wrap',
}));

// Article content with optimized reading
export const ArticleContent = styled(Box)(({ theme }) => ({
  fontSize: '1.1rem',
  lineHeight: 1.8,
  color: theme.palette.text.primary,
  '& h2': {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  '& h3': {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
  },
  '& p': {
    marginBottom: theme.spacing(2),
  },
  '& ul, & ol': {
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  '& li': {
    marginBottom: theme.spacing(1),
  },
}));

// Article section for structured content
export const ArticleSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));
